<template>
  <div class="home-form-wrapper">
    <PageTitleTop :main-title="'API registration form'"
                  :subtitle="'Enter your first and last name and email to register for an API key.'"/>

    <FormWrapper :post-form-data="sendRegistration">

      <!-- First and Last name field -->
      <InputField
        :field-title="'First and last name*'"
        :field-name="'name'"
        :rule="{'required': true, 'alpha_spaces': true}"
        :type="'text'"
        :placeholder="'Enter your first and last name'"
        :debounce="0"
        :register-error="registerError">
      </InputField>

      <!-- E-mail field -->
      <InputField
        :field-title="'E-mail*'"
        :field-name="'email'"
        :rule="'required'"
        :type="'email'"
        :placeholder="'Enter your e-mail'"
        :debounce="0"
        :register-error="registerError">
      </InputField>

      <div v-if="registerError" class="text-error-field">
        {{ registerErrorText }}
      </div>

      <VueRecaptcha class="recaptcha-content"
                    :sitekey="siteKey"
                    @verify="verifyRecaptcha"
                    ref="captcha"/>

      <!-- Send register button-->
      <template v-slot:buttonSubmit="{ invalid }">
        <div class="btn-submit-wrapper">
          <button :class="{ 'button-disabled' : invalid || !submitButtonEnabled }"
                  :disabled="invalid || !submitButtonEnabled"
                  type="submit"
                  class="button-main btn-register">
            Get your API key
          </button>
        </div>
      </template>
    </FormWrapper>

    <KeyBox v-if="apiKey !== ''"
            :api-key="apiKey"
            :copy-to-clipboard="copyToClipboard"/>
  </div>
</template>

<script>
  import PageTitleTop from "@/components/partials/PageTitleTop";
  import FormWrapper from "@/components/form/FormWrapper";
  import InputField from "@/components/form/InputField";
  import {SEND_REGISTRATION} from "@/store/actions";
  import KeyBox from "@/components/partials/KeyBox";
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    name: 'HomeForm',
    components: {
      KeyBox,
      InputField,
      FormWrapper,
      PageTitleTop,
      VueRecaptcha
    },
    data: () => ({
      submitButtonEnabled: false,
      recaptchaToken: '',
      siteKey: process.env.VUE_APP_RECAPTCHA_KEY_V2,
    }),
    computed: {
      apiKey: function () {
        return this.$store.getters.getApiKey;
      },
      registerError: function () {
        return this.$store.getters.getAuthRegisterError;
      },
      registerErrorText: function () {
        return this.$store.getters.getAuthRegisterErrorText;
      }
    },
    watch: {
      apiKey: function (newValue) {
        if (newValue !== '') {
          this.listenOnPageChange();
        }
      }
    },
    methods: {
      verifyRecaptcha: function (response) {
        this.recaptchaToken = response;
        this.enableSubmitButton();
      },
      enableSubmitButton: function () {
        this.submitButtonEnabled = true;
      },
      sendRegistration: function (data) {
        data.token = this.recaptchaToken;
        this.$store.dispatch(SEND_REGISTRATION, data).then(response => {
          if (!response) {
            this.$refs.captcha.reset();
          }
        });
      },
      copyToClipboard: function () {
        // Get the text field.
        let copyText = document.getElementById("api-key");

        //Select the text field
        copyText.select();
        copyText.setSelectionRange(0, 99999); /*For mobile devices*/

        // Copy the text inside the text field
        document.execCommand("copy");
      },
      listenOnPageChange: function () {
        window.addEventListener("beforeunload", function (event) {
          event.returnValue = "Once you close or refresh this window, you will no longer be able to see your API key. Please, make sure you have saved your API key.";
        });
      }
    },
  }
</script>

<style scoped lang="scss">
  @import "../assets/css/_base.variables.scss";

  .home-form-wrapper {
    margin: 0 auto;
    max-width: 550px;
    padding: 25px 10px;
  }

  .btn-register {
    margin-top: 15px;
  }

  @media screen and (min-width: $screen-md) {
    .home-form-wrapper {
      padding: 25px 70px;
    }
  }

</style>
